<ng-container *cdkPortal>
  <ng-content></ng-content>
</ng-container>